import { useContext } from 'react';

import { AccordionContainer } from '@/components/AccordionContainer';
import { EmptySectionContactAdmin } from '@/components/EmptySectionContactAdmin';
import { OrderStatusCategoryRow } from '@/components/OrderStatusCategoryRow';
import { SettingsContext } from '@/contexts/SettingsContext';
import useTranslation from '@/hooks/useTranslation';

export const SectionOrderOverview = () => {
  const t = useTranslation();
  const { orderStatusOrderForUser } = useContext(SettingsContext);
  return (
    <AccordionContainer keyName={'ORDER_OVERVIEW'} visibleTitle={t('section.ORDER_OVERVIEW')}>
      {orderStatusOrderForUser.map((orderStatus) => (
        <OrderStatusCategoryRow key={`order-status-category-row-${orderStatus}`} status={orderStatus} />
      ))}
      <EmptySectionContactAdmin items={orderStatusOrderForUser} sectionName={t('section.ORDER_OVERVIEW')} />
    </AccordionContainer>
  );
};
